import React from 'react'
import { Number, Slider, DropdownWithCustomInput, Checkbox } from 'components'
import findIndex from 'lodash/findIndex'

export default function Education(props) {
  return [
    <Number
      id={props.goal.id}
      currency
      label="Cost of college today"
      message="every year"
      value={props.goal.currentSpend}
      min={100000}
      max={100000000}
      handleUpdate={value =>
        props.setGoalProp(props.goal.id, 'currentSpend', value)
      }
    />,
    <Number
      id={props.goal.id}
      label="My kid will start college after"
      message="years"
      value={props.goal.spendStartAge - props.profile.age}
      min={1}
      max={props.goal.spendStopAge}
      handleUpdate={value => {
        const diff = props.goal.spendStopAge - props.goal.spendStartAge
        props.setGoalProp(
          props.goal.id,
          'spendStartAge',
          value + props.profile.age
        )
        props.setGoalProp(
          props.goal.id,
          'spendStopAge',
          value + props.profile.age + diff
        )
      }}
    />,
    <Number
      id={props.goal.id}
      label="College duration"
      message="years"
      value={props.goal.spendStopAge - props.goal.spendStartAge}
      min={2}
      max={7}
      handleUpdate={value =>
        props.setGoalProp(
          props.goal.id,
          'spendStopAge',
          value + props.goal.spendStartAge
        )
      }
    />,
    <Slider
      id={props.goal.id}
      label="I will invest regularly from"
      min={props.profile.age}
      max={props.goal.spendStartAge}
      start={props.goal.investStartAge}
      stop={props.goal.investStopAge}
      updateStart={value =>
        props.setGoalProp(props.goal.id, 'investStartAge', value)
      }
      updateStop={value =>
        props.setGoalProp(props.goal.id, 'investStopAge', value)
      }
    />,
    <DropdownWithCustomInput
      label="My asset allocation will be"
      message="before college starts"
      menuItems={props.returnProfiles}
      defaultItem={findIndex(props.returnProfiles, [
        'value',
        props.goal.investmentPeriodReturn,
      ])}
      handleUpdate={value =>
        props.setGoalProp(props.goal.id, 'investmentPeriodReturn', value)
      }
      isCustom={props.goal.customInvestmentPeriodEquity !== null}
      customLabel="Equity allocation before college starts"
      customMessage="percent"
      customValue={props.goal.customInvestmentPeriodEquity || 0}
      handleCustomInput={value =>
        props.setGoalProp(props.goal.id, 'customInvestmentPeriodEquity', value)
      }
    />,
    <DropdownWithCustomInput
      label="My asset allocation will be"
      message="during college"
      menuItems={props.returnProfiles}
      defaultItem={findIndex(props.returnProfiles, [
        'value',
        props.goal.spendingPeriodReturn,
      ])}
      handleUpdate={value =>
        props.setGoalProp(props.goal.id, 'spendingPeriodReturn', value)
      }
      isCustom={props.goal.customSpendingPeriodEquity !== null}
      customLabel="Equity allocation during college"
      customMessage="percent"
      customValue={props.goal.customSpendingPeriodEquity || 0}
      handleCustomInput={value =>
        props.setGoalProp(props.goal.id, 'customSpendingPeriodEquity', value)
      }
    />,
    <Number
      id={props.goal.id}
      label="I expect college fees inflation to be"
      message="percent"
      value={props.goal.inflation}
      min={0}
      max={20}
      handleUpdate={value =>
        props.setGoalProp(props.goal.id, 'inflation', value)
      }
    />,
    <Checkbox
      checked={props.goal.scaling}
      label="Enable scaling"
      name="scaling"
      message="Only impacts deployment of funds when invested with Capitalmind Wealth PMS"
      handleUpdate={value => props.setGoalProp(props.goal.id, 'scaling', value)}
    />,
  ].map((input, idx) => <li key={`${props.goal.id}-${idx}`}>{input}</li>)
}



// WEBPACK FOOTER //
// ./src/components/forms/Education.js